export const KeyCode = {
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  HOME: 36,
  END: 35,
  BACKSPACE: 8,
};

/**
 * createKeyHandler
 * create handler function for specific keycode or keycodes
 * @param  {...number} keyCodes
 */
const createKeyHandler =
  (...keyCodes) =>
  (callback) =>
  (event) => {
    const eventKeyCode = event.keyCode || event.which;

    if (keyCodes.includes(eventKeyCode)) {
      callback(event);
    }
  };

/**
 * handleEnterEvent
 * create handler function only for key event "Enter"
 */
export const handleEnterEvent = createKeyHandler(KeyCode.ENTER);
